import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import AdSense from './components/AdSense';
import Home from './pages/Home';
import Performance from './pages/Performance';
import Security from './pages/Security';
import HighAvailability from './pages/HighAvailability';
import BackupRecovery from './pages/BackupRecovery';
import Automation from './pages/Automation';
import Installation from './pages/Installation';
import Architecture from './pages/Architecture';
import Maintenance from './pages/Maintenance';
import AzureSQL from './pages/AzureSQL';
import About from './pages/About';
import Authors from './pages/Authors';
import ScriptPage from './pages/ScriptPage';
import ArticlePage from './pages/ArticlePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminEditor from './pages/AdminEditor';
import UserManagement from './pages/UserManagement';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const AppContent = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      <Header />
      <div className="main-container">
        <Sidebar />
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/security" element={<Security />} />
            <Route path="/high-availability" element={<HighAvailability />} />
            <Route path="/backup-recovery" element={<BackupRecovery />} />
            <Route path="/automation" element={<Automation />} />
            <Route path="/installation" element={<Installation />} />
            <Route path="/architecture" element={<Architecture />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/azure-sql" element={<AzureSQL />} />
            <Route path="/about" element={<About />} />
            <Route path="/authors" element={<Authors />} />
            <Route path="/script/:id" element={<ScriptPage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/editor/:id?" element={
              <ProtectedRoute>
                <AdminEditor />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <aside className="adsense-sidebar">
          <AdSense />
        </aside>
      </div>
      {!isAdminPage && <Footer />}
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <DataProvider>
          <Router>
            <AppContent />
          </Router>
        </DataProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;